import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserProvider } from '../../providers/user';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';

/**
 * Generated class for the BrowserPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@IonicPage()
@Component({
  selector: 'page-browser',
  templateUrl: 'browser.html',
})
export class BrowserPage {
  title: string;
  url: string;
  hideNav: string = 'no';
  constructor(private iab: InAppBrowser, public userProvider: UserProvider, public navCtrl: NavController, public navParams: NavParams) {
    this.title = this.navParams.get("title");
    this.url = this.navParams.get("url");
    this.hideNav = this.navParams.get("hide_nav");

    const options: InAppBrowserOptions = {
      location: 'no',
      zoom: 'yes',
      hidenavigationbuttons: 'no',
      hardwareback: 'yes',
    };

    if(this.hideNav == 'yes') {
        const options: InAppBrowserOptions = {
            location: 'no',
            zoom: 'yes',
            hidenavigationbuttons: 'yes',
            hardwareback: 'yes',
        };
        const browser = this.iab.create(this.url,'_blank', options);
        browser.on('exit')
        .subscribe(
            ((event) => {
                    this.navCtrl.pop();
                }
            ));
    } else {
        const options: InAppBrowserOptions = {
            zoom: 'yes',
            hardwareback: 'yes',
        };
        const browser = this.iab.create(this.url,'_blank', options);
        browser.on('exit')
        .subscribe(
            ((event) => {
                    this.navCtrl.pop();
                }
            ));
    }



  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BrowserPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/browser/browser.ts